import axios from 'axios'

export const createUser = async (data) => {
  try {
    let resp = await axios.post(
      process.env.REACT_APP_LOCAL_URL + '/api/user/create-user',
      data
    )
    if (resp.status === 200 && resp.data._id) {
      return { success: true, data: resp.data }
    } else {
      return resp
    }
  } catch (err) {
    return err
  }
}

export const updateUser = async (data) => {
  try {
    data.userName = data.info.contact.email
    let resp = await axios.post(
      process.env.REACT_APP_LOCAL_URL + '/api/user/update',
      data
    )
    if (resp.status === 200 && resp.data._id) {
      return { success: true, data: resp.data }
    } else {
      return resp
    }
  } catch (err) {
    return err
  }
}
